module.exports = __webpack_public_path__ + "img/tgtw_x2.34779cd2.webp";